import { Component } from '@angular/core';
import { ActionIconsComponent } from '../../../components/action-icons/action-icons.component';
import { CompanyFitComponent as SharedCompanyFitComponent } from '../../../components/company-fit/company-fit.component';

@Component({
  selector: 'app-space-company-fit-page',
  standalone: true,
  imports: [SharedCompanyFitComponent, ActionIconsComponent],
  templateUrl: './company-fit.component.html',
  styleUrl: './company-fit.component.scss'
})
export class SpaceCompanyFitComponent {}
